import "./flip_card.scss";
import React, { useContext } from "react";

import languageContext from "../../context/languageContext";

const Flip_Card = () => {
  const { language, wichOne, langAvailable } = useContext(languageContext);

  const classCardContent =
    wichOne === langAvailable.ENGLISH
      ? "card-content-english"
      : "card-content-spanish";

  return (
    <div className="personal-card">
      <div className={classCardContent}>
        <div className="card-front">
          <h1 className="card-front__title heading-primary">
            {language.personalInformation.title}
          </h1>
          <h2 className="card-front__subtitle heading-secondary">
            {language.personalInformation.subtitle}
          </h2>
        </div>
        <div className="card-back">
          <p className="card-back__text">{language.personalInformation.text}</p>
        </div>
      </div>
    </div>
  );
};

export default Flip_Card;
